const EmailPreferencesPanel = ({ values, onToggle, onUpdate, onCancel }) => {
  return (
    <div id="ChangeEmailDiv">
      <h3 className="user-profile-subheading">Email Preferences</h3>
      <div className="user-profile-email-copy">
        <p>
          You can choose to subscribe to either, both, or choose not to be notified by selecting or deselecting the
          check boxes below, then clicking the Update button. All emails will be sent to the email address associated
          with your user name. If you would like to change your user name, please contact Investor Relations.
        </p>

        <div>
          <input
            type="checkbox"
            id="chkDocuments"
            checked={Boolean(values.isDocEmail)}
            onChange={(e) => onToggle("isDocEmail", e.target.checked)}
          />
          <label htmlFor="chkDocuments" className="user-profile-checkbox-label">Client Statements Notification</label>
        </div>

        <div>
          <input
            type="checkbox"
            id="chkManagerCommentary"
            checked={Boolean(values.isManagerCommentary)}
            onChange={(e) => onToggle("isManagerCommentary", e.target.checked)}
          />
          <label htmlFor="chkManagerCommentary" className="user-profile-checkbox-label">Manager Commentary</label>
        </div>

        <div>
          <input
            type="checkbox"
            id="chkTaxDocumentsNotification"
            checked={Boolean(values.isTaxDocumentsNotification)}
            onChange={(e) => onToggle("isTaxDocumentsNotification", e.target.checked)}
          />
          <label htmlFor="chkTaxDocumentsNotification" className="user-profile-checkbox-label">Tax Documents Notification</label>
        </div>
      </div>

      <div className="row user-profile-top-gap">
        <div className="col-sm-7">
          <button type="button" className="btn btn-primary btn_profile" onClick={onUpdate}>Update</button>
          <button type="button" className="btn btn-primary btn_profile" onClick={onCancel}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default EmailPreferencesPanel;
